// extracted by mini-css-extract-plugin
module.exports = {"dropArea":"style__dropArea__IJ+lM","active":"style__active__nYMD9","fileDescriptor":"style__fileDescriptor__GtEeL"};